<template lang="pug" v-slot:content>
section.src-components-cajas
  //v-app-bar(app color="indigo darken-2" dark)
    nav
      router-link.ma-2(to="/")
        v-icon mdi-home
        span.ma-2 Cajas
      router-link.ma-2(to="/report/resumencaja")
        v-icon mdi-chart-box-plus-outline
        span.ma-2 Cajas Por Fecha        
    v-app-bar-title Cajas 
    v-spacer
    v-btn(@click="changeDB(false)" color="secondary" dark small) Local Directo
    v-btn(@click="changeDB(true)" color="secondary" dark small) Datos Online
    v-btn(@click="getCajas()" color="secondary" dark small) #[v-icon mdi-update] Actualizar
  v-progress-linear(:active='loading' :indeterminate='loading' absolute='' color='teal accent-4')
  v-card.ma-2
    v-card-title
      v-text-field(v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details)
    v-data-table.elevation-1(
      sort-by="NROTURNO"
      sort-desc=true
      :search="search" 
      dense 
      :headers="headers" 
      :items="cajas" 
      :items-per-page="10")
      template(v-slot:item.TotalGeneral="{item}")
        span {{$formatNumber(item.TotalGeneral)}}
      template(v-slot:item.apertura="{item}")
        span {{$formatDate(item.fechaapertura)}} {{$formatTime(item.horaapertura)}}
      template(v-slot:item.cierre="{item}")
        span {{$formatDate(item.fechacierre)}} {{$formatTime(item.horacierre)}}
      template(v-slot:item.actions="{item}")
        v-icon.mr-2(@click="toventa(item)") mdi-pencil
        //v-icon.mr-2(@click="toresumen(item)") mdi-cash-register

</template>

<script lang="js">
  import { EventBus } from '../event-bus';
  import {Cajas} from "../db/Cajas"
  export default  {
    name: 'src-components-cajas',
    props: [],
    mounted () {
      this.getCajas()
      EventBus.$off('toolbar_click')
      EventBus.$on('toolbar_click', (event)=>{
        if (event=='update') {
          this.dbcajas = Cajas(this)
          this.getCajas()
        }
      });
    },
    data () {
      return {
        dbcajas:Cajas(this),
        search:"",
        loading:true,
        headers: [
          { text: 'Numero ', value: 'NROTURNO',align: 'end' },
          { text: 'Punto de Venta ', value: 'idpuesto', align: 'end' },
          { text: 'Abre', value: 'apertura' },
          { text: 'Cierre', value: 'cierre' },
          { text: 'Total', value: 'TotalGeneral', align: 'end' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],    
        cajas:[],
      }
    },
    methods: {
      toventa(item) {
        this.$router.push(`/ventas/${item.Idsesion}/${item.estado}`)
      },
      toresumen(item) {
        this.$store.commit('caja',item)
        this.$router.push({
            name: 'Resumen de Caja',
        })
      },
      getCajas() {
        this.loading = true
        this.dbcajas.getCajas().then((ret) => {
          this.cajas = ret.data
        }).catch((err) => {
          if (err.response?.data?.message) {
            alert(err.response.data.message)
          } else {
            alert(err.message)
          }
        })
        .finally(() => {
          this.loading = false
        });
      },      
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .src-components-cajas {

  }
</style>
